/**
 * @fileoverview POST handler for the "/engagement/canvas/canvas_property_update_step_preview" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasContextUpdateStepPreviewCacheKeys } from "./constants";
import type {
  PostEngagementCanvasContextUpdateStepPreviewProps,
  EngagementCanvasContextUpdateStepPreviewResult,
  SelectedUserIdProps,
  RandomUserProps,
  CustomUserProps,
} from "./types";

export const postEngagementCanvasContextUpdateStepPreview = reactQueryMutationAdapter(
  engagementCanvasContextUpdateStepPreviewCacheKeys,
  (
    props: PostEngagementCanvasContextUpdateStepPreviewProps
  ): Promise<EngagementCanvasContextUpdateStepPreviewResult> => {
    if (isSearchUser(props) || isRandomUser(props)) {
      const { userId = null, appGroupId, variables, workflowVariationId, workflowId } = props;
      return fetch(
        "/engagement/canvas/context_update_step_preview",
        "POST",
        {
          app_group_id: appGroupId,
          user_id: userId,
          variables: variables,
          workflow_id: workflowId,
          workflow_variation_id: workflowVariationId,
        },
        undefined,
        {
          // don't display a modal on fetch errors
          propagateFetchRequestError: false,
        }
      );
    }
    const { appGroupId, variables, workflowVariationId, workflowId, customUserHash, triggerPropertiesHash } = props;
    return fetch(
      "/engagement/canvas/context_update_step_preview",
      "POST",
      {
        app_group_id: appGroupId,
        custom_user_hash: customUserHash,
        trigger_properties_hash: triggerPropertiesHash,
        variables: variables,
        workflow_id: workflowId,
        workflow_variation_id: workflowVariationId,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);

export const isSearchUser = (
  props: PostEngagementCanvasContextUpdateStepPreviewProps
): props is SelectedUserIdProps => props.type === "Search User";

export const isRandomUser = (props: PostEngagementCanvasContextUpdateStepPreviewProps): props is RandomUserProps =>
  props.type === "Random User";

export const isCustomUser = (props: PostEngagementCanvasContextUpdateStepPreviewProps): props is CustomUserProps =>
  props.type === "Custom User";
